import { useState } from 'react'

import { useAttachments } from './useAttachments'
import { createZendeskAttachmentUploader } from '../lib/attachmentUploader'
import { useAdviserAnalytics } from '../analytics/use-adviser-analytics'
import type { AttachmentUploader } from '../lib/attachments.types'

export const useAttachmentsWithAnalytics = () => {
  const [uploader] = useState<AttachmentUploader>(() =>
    createZendeskAttachmentUploader()
  )
  const {
    trackAttachmentAdded,
    trackAttachmentUploadFailed,
    trackAttachmentRemoved,
    trackAttachmentsSubmitted,
  } = useAdviserAnalytics()

  const attachments = useAttachments(uploader, {
    onAdded: ({ size, contentType }) =>
      trackAttachmentAdded({ size, contentType }),
    onUploadFailed: ({ reason, percent }) =>
      trackAttachmentUploadFailed({ reason, percent }),
    onRemoved: trackAttachmentRemoved,
  })

  return {
    ...attachments,
    trackSubmitted: (): void => {
      trackAttachmentsSubmitted({ count: attachments.refs.length })
    },
  }
}
